import { Button, message, Upload, UploadFile } from "antd";
import { useState } from "react";
import useUploadAsset from "../../hooks/useUploadAsset";

export default function UploadButton(props: {
  fileKey: string;
  onSuccess: (url: string) => void;
}) {
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [messageApi, ctxHolder] = message.useMessage();
  const { uploadFile } = useUploadAsset();
  async function handleUpload(f: File) {
    console.log(f, props.fileKey);
    setFileList([]);
    messageApi.loading("Uploading file");

    const res = await uploadFile(props.fileKey, f);
    messageApi.destroy();
    if (res === undefined) {
      messageApi.error("Error uploading file. If this issue persists, "
                       + "please contact the development team");
      return;
    }

    messageApi.success("Uploaded file successfully");
    props.onSuccess(res.resultFileUrl);
    return false;
  }

  return (
    <Upload
      beforeUpload={handleUpload}
      fileList={fileList}
    >
      {ctxHolder}
      <Button type="primary">
        Upload
      </Button>
    </Upload>
  )
}